import { gql, useMutation } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import { accountsClient } from '../../../apollo/api'

const MUTATION = gql`
  mutation RemoveUserGroups($ids: [Int]) {
    removeUserGroups(ids: $ids)
  }
`

export const useRemoveGroups = () => {
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['Groups', 'GroupsCount'],
    client: accountsClient
  })
  const notify = useNotification()
  const modal = useAlert()
  const { t } = useTranslation('common')

  const handleRequest = ids => {
    if (!modal.confirm({ title: t('confirmRemove') })) return false

    return request({ variables: { ids } }).then(resp => {
      if (!!resp.errors) {
        notify.error({ title: t('errorDelete') })
      }
    })
  }

  return [handleRequest, state]
}
